import {
  type AuthUser,
  fetchAuthSession,
  fetchUserAttributes,
  getCurrentUser,
} from 'aws-amplify/auth';

import { getCurrentAuthProvider } from './authProviderState';

export const ampGetEmail = async (): Promise<string | null> => {
  try {
    // For WoningNet SSO, email is in the ID token
    if (getCurrentAuthProvider() === 'woningnet') {
      const authSession = await fetchAuthSession();
      return (authSession.tokens?.idToken?.payload.email ?? null) as string | null;
    }

    const attributes = await fetchUserAttributes();
    return attributes.email ?? null;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    return null;
  }
};

export const ampGetUserId = async (): Promise<string | null> => {
  try {
    // For WoningNet SSO, user ID is the 'sub' claim in access token
    if (getCurrentAuthProvider() === 'woningnet') {
      const authSession = await fetchAuthSession();
      return (authSession.tokens?.accessToken?.payload.sub ?? null);
    }

    const currentUser: AuthUser = await getCurrentUser();
    return currentUser.userId;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    return null;
  }
};

export const ampIsAuthenticated = async (): Promise<boolean> => {
  try {
    const { tokens } = await fetchAuthSession();
    return Boolean(tokens);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    return false;
  }
};
